import { useState, useCallback } from "react";
import {
  getNotifications,
  markNotificationRead,
  markAllNotificationsRead,
  getNotificationsSummary,
} from "../../../../api/marketplace";

export function useNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchNotifications = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await getNotifications(params);
      setNotifications(res.data);
    } catch (err) {
      setError(err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchSummary = useCallback(async () => {
    try {
      const res = await getNotificationsSummary();
      setSummary(res.data);
    } catch (err) {
      console.error("Failed to fetch notifications summary:", err);
    }
  }, []);

  const markRead = useCallback(async (id) => {
    await markNotificationRead(id);
    await fetchNotifications();
    await fetchSummary();
  }, [fetchNotifications, fetchSummary]);

  const markAllRead = useCallback(async () => {
    await markAllNotificationsRead();
    await fetchNotifications();
    await fetchSummary();
  }, [fetchNotifications, fetchSummary]);

  return {
    notifications,
    summary,
    loading,
    error,
    fetchNotifications,
    fetchSummary,
    markRead,
    markAllRead,
  };
}
